import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ResizeDetectionService } from '../../services/resize-detection.service';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent {
    images: string[] = [];
    currentIndex: number = 0;
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;



    constructor(private router: Router) {}

    ngOnInit() {
        if (localStorage.getItem('cookie')) {
            this.cookiePopupVisibility = false;
        } else this.cookiePopupVisibility = true;
    }

    goToPlan() {
        this.router.navigate(["order-flow"]);
    }

    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;


}
